import { jsx as _jsx } from "react/jsx-runtime";
import { LoadingOutlined } from "@ant-design/icons";
import { Button, Result } from "antd";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { IMPREZA_BUTTON_PROPS } from "../../../components/provider.js";
import { RealCommerceError } from "../../../exceptions/realCommerceError.js";
import { useStores } from "../../../store/stores.js";
import { __ } from "../../../utils/i18n.js";
const ClaimCashback = observer(({ token })=>{
    const { checkoutV2Store } = useStores();
    const { busyCashbackClaim, claimedCashback } = checkoutV2Store;
    const [doClaim, setDoClaim] = useState(false);
    useEffect(()=>{
        if (doClaim) {
            checkoutV2Store.claimCashback(token);
        }
    }, [
        doClaim
    ]);
    return !doClaim ? /*#__PURE__*/ _jsx(Result, {
        status: "info",
        title: __("Do you wish to have your cashback paid out? The payout will be made to the payment method you used when placing the order."),
        extra: /*#__PURE__*/ _jsx(Button, {
            type: "primary",
            size: "large",
            onClick: ()=>setDoClaim(true),
            ...IMPREZA_BUTTON_PROPS,
            children: __("Claim now")
        })
    }) : busyCashbackClaim ? /*#__PURE__*/ _jsx(Result, {
        title: __("Try to claim cashback..."),
        icon: /*#__PURE__*/ _jsx(LoadingOutlined, {})
    }) : claimedCashback instanceof RealCommerceError ? /*#__PURE__*/ _jsx(Result, {
        status: "error",
        title: claimedCashback.message
    }) : claimedCashback && /*#__PURE__*/ _jsx(Result, {
        status: "success",
        title: __("Your %s cashback will be paid out within three days. Thank you for taking part in the promotion!", claimedCashback.name)
    });
});
export { ClaimCashback };
